function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import './button.scss';
export var Button = function (_ref) {
  var _ref$action = _ref.action,
    action = _ref$action === void 0 ? 'default' : _ref$action,
    element = _ref.element,
    href = _ref.href,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    other = _objectWithoutProperties(_ref, ["action", "element", "href", "children", "className"]);
  var Element = element || (href ? 'a' : 'button');
  return /*#__PURE__*/React.createElement(Element, _extends({
    className: "a-btn a-btn--".concat(action, " ").concat(className),
    href: href
  }, other), children);
};
export default Button;